import DocModuler from '../../DocModuler';

/**
 * 设置水印
 * 原理：
 *  1、内存中创建一个canvas元素，设置宽高为原容器的对角线大小。
 *  2、设置参数，在这个canvas上绘制水印文本（不倾斜）。
 *  3、调用canvas.toDataURL()方法导出base64图片。
 *  4、调用fabric的setOverlayImage方法设置水印
 * @param {*} cw 原文档对象容器的宽
 * @param {*} ch 原文档对象容器的高
 * @returns
 */
export default function setWatermark(cw, ch) {
  return new Promise((resolve, reject) => {
    try {
      // 水印容器用正方形，边长为原容器的斜边，要保证旋转后能完全覆盖
      const maxSide = Math.ceil(Math.sqrt(Math.pow(cw, 2) + Math.pow(ch, 2)));

      // 创建一个 canvas 元素，并设置宽高
      let canvas = document.createElement('canvas');
      canvas.width = maxSide;
      canvas.height = maxSide;
      // 创建2d绘制api
      const ctx = canvas.getContext('2d');
      // 获取默认字体
      const rootFontFamily = (
        document.documentElement.currentStyle
          ? document.documentElement.currentStyle
          : window.getComputedStyle(document.documentElement)
      ).fontFamily;
      // 设置水印文字大小、字体、颜色
      ctx.font = `${DocModuler.watermarkOption.fontSize}px ${rootFontFamily}`;
      ctx.fillStyle = DocModuler.watermarkOption.color;

      // 文本内容
      const text = DocModuler.watermarkOption.text;
      const metrics = ctx.measureText(text);
      // 文字宽度
      const fontWidth = metrics.width;
      // 文字高度
      // 兼容性处理，fontBoundingBoxAscent属性值可能没有， 最终兜底的文字高度设置为16
      const fontHeight = metrics.fontBoundingBoxAscent
        ? Math.ceil(metrics.fontBoundingBoxAscent + metrics.fontBoundingBoxDescent)
        : metrics.actualBoundingBoxAscent
        ? Math.ceil(metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent)
        : 16;

      // 绘制文字的横线偏移量
      const woffset = fontWidth + Math.ceil(fontWidth / text.length) * 2;
      // 高度偏移量
      const hoffset = 3 * fontHeight;
      const fixbu = 1.5 * fontHeight;

      let flag = 0;
      for (let x = 0; x <= canvas.width; x = x + woffset) {
        flag++;
        let bu = flag % 2 === 1 ? fixbu : 0;
        for (let y = 0 + bu; y <= canvas.height; y = y + hoffset) {
          ctx.fillText(text, x, y);
        }
      }
      // 返回base64编码图片，质量1.0(默认是0.92)
      const imgDataSrc = canvas.toDataURL('image/png', 1.0);
      resolve(imgDataSrc);
      canvas = null;
    } catch (err) {
      reject(err);
    }
  });
}
